/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { 
  Grid, 
  Typography, 
  TextField, 
  Button, 
  Stack,
  Tooltip,
  IconButton,
  Box,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  useMediaQuery,
  Card,
  CardContent
} from '@mui/material';

import '../styles/solicVacacion.css';

// Componentes.
import Heading from '../components/heading/Heading';
import Item from '../components/custom/Item';
import Formatter from '../scripts/formatters';
import CustomNoRowsOlverlay from '../components/custom/CustomNoRowsOlverlay';
import msgNotificacion from '../scripts/notification';
import msgAlerta from '../scripts/alert';
import SolicitudesDataGrid from '../components/styledDataGrid/SolicitudesDataGrid';

// Iconos
import BlockIcon from '@mui/icons-material/Block';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

// Redux
import { useDispatch } from 'react-redux';
import { showProgress } from '../redux/reducers/progress.Slice';
import { PAGE_SIZE, NAME_PROJECT } from '../redux/constants/index';

// Servicios
import EmpleadoService from '../services/empleadoService';

export default function SolicVacacion() {
  const dispatch = useDispatch()
  const userLogin = JSON.parse(localStorage.getItem('user'))
  const inputEls = useRef([])
  const isMobile = useMediaQuery('(max-width: 740px)')
  let hiddeButtonsMobile = [3,4,5]

  //
  const [loading, setLoading] = useState(false)
  const [isVacacion, setIsVacacion] = useState(true)
  const [isMediodia, setIsMediodia] = useState(false)
  const [isHorario, setIsHorario] = useState(false)
  const [isPermisoDiaPersonal, setIsPermisoDiaPersonal] = useState(false)
  const [dataSolicitud, setDataSolicitud] = useState([])
  const [dataTipoSolicitud, setDataTipoSolicitud] = useState([])
  const [dataTipoVacacion, setDataTipoVacacion] = useState([])
  const [dataTipoVacacionFilter, setDataTipoVacacionFilter] = useState([])
  const [valueSelect, setValueSelect] = useState({ 
    tipoSolicitudSelected: '', 
    tipoVacacionSelected: '', 
    tipoHorarioSelected: '' 
  })
  const [values, setValues] = useState({
    fechaInicial: '',
    fechaFinal: '',    
    cantidad: 0,
    acumulado: 0,
    saldo: 0
  })

  //
  const [motivo, setMotivo] = useState('')
  const [startTime, setStartTime] = useState('')
  const [endTime, setEndTime] = useState('')
  const minTime = '08:00';
  const maxTime = '17:00';
  const blockedStartTime = '12:00';
  const blockedEndTime = '13:00';
  
  //
  const rowTipoHorario = [
    {
      Id: 1,
      Nombre: 'POR LA MAÑANA'
    },
    {
      Id: 2,
      Nombre: 'POR LA TARDE'
    }
  ]

  // Columns
  const columns = [
    {
      field: 'IdSolicitud',
      headerName: 'No. Solicitud',      
      align: 'center',
      headerAlign: 'center',      
      width: 100,
    },
    {
      field: 'FechaInicio',
      headerName: 'Fecha Inicial',      
      align: 'center',
      headerAlign: 'center',
      width: 140,      
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value)
    },
    {
      field: 'FechaFinal',
      headerName: 'Fecha Final',      
      align: 'center',
      headerAlign: 'center',
      width: 140,
      valueFormatter: ( value ) => Formatter.dateTimeFormatter(value)
    },
    {
      field: 'CantDias',
      headerName: 'Días',      
      align: 'center',
      headerAlign: 'center',
      width: 60,
    },
    {
      field: 'CantHoras',
      headerName: 'Horas',
      align: 'center',
      headerAlign: 'center',
      width: 60,
    },
    {
      field: 'TipoSolicitud',
      headerName: 'Tipo',
      align: 'center',
      headerAlign: 'center',
      width: 120,
    },
    {
      field: 'TipoVacacion',
      headerName: 'Solicitud',
      headerAlign: 'center',      
      minWidth: 180,
      flex: 1,
    },
    {
      field: 'Estado',
      headerName: 'Estado',
      align: 'center',
      headerAlign: 'center',
      width: 150,
      renderCell: (props) => {
        return (
          <div className={`MuiDataGrid-overlayWrapperInner MuiDataGrid-cellContent ${props.row.CssBg} rounded-4`}>
            <i className={`${props.row.CssIcon} mx-1 py-1`}></i>
            <Typography style={{ fontSize: 13 }} className='me-1'>{props.value}</Typography>
          </div>
        )
      }
    },
    {
      field: 'Motivo',
      headerName: 'Motivo del Permiso',
      headerAlign: 'center',
      minWith: 300,
      flex: 1,
    },
    {
      field: 'Eliminar',
      headerName: 'Anular',
      width: 60,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => {
        const dataObject = params.row

        const eliminarLinea = () => {
          try {
            msgAlerta('Anular solicitud', '¿Estás seguro que la desea anular?', 'question', anularSolicitud)
          } catch (error) {
            console.error(error)
          }
        }

        const anularSolicitud = () => {
          try {            
            const data = {
              solicitud: dataObject?.IdSolicitud,
              codEmpleado: userLogin.CodigoEmpleado
            }
            
            EmpleadoService.anularSolicitud(data)
              .then((response) => {
                if (!response) {
                  msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
                  return
                }
                
                if (response.Codigo === 1) {
                  msgAlerta('Éxito!', response.Mensaje, 'success')
                  
                  getSolicitudes(data)
                } else {                  
                  msgAlerta('Alerta!', response.Mensaje, 'warning')
                }
              })
              .catch((error) => {
                console.log('Error:', error.message)
              })
          } catch (error) {
            console.error(error)
          }
        }
        
        return (
          <Stack direction="row" spacing={1}>
            <Tooltip title='Anular Solicitud'>
              <IconButton aria-label='buscar' color='error' onClick={eliminarLinea}>
                <BlockIcon fontSize='medium' />
              </IconButton>
            </Tooltip>
          </Stack>
        );
        
      }
    },
  ]

  const handleChange = (event) => {
    try {
      // Actualizar el estado de los valores del formulario
      const { name, value } = event.target      

      // Actualizar el estado values
      setValues((prevValues) => ({
        ...prevValues,
        [name]: value,
      }))
      
    } catch (error) {
      console.error(error)
    }
  }

  const handleStartTimeChange = (event) => {
    try {
      const newHour = event.target.value;
      
      if (!isTimeInRange(newHour, 'I')) {
        setStartTime(newHour)
        handleFocusHours(newHour, endTime)
      } else {
        msgNotificacion('La hora de fin seleccionada está fuera del rango permitido. El rango correcto es: De 08:00 a 12:00 y de 13:00 17:00 horas.', 'warning')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleEndTimeChange = (event) => {
    try {
      const newHour = event.target.value;

      if (!isTimeInRange(newHour, 'F')) {
        setEndTime(newHour)
        handleFocusHours(startTime, newHour)        
      } else {
        msgNotificacion('La hora de fin seleccionada está fuera del rango permitido. El rango correcto es: De 08:00 a 12:00 y de 13:00 17:00 horas.', 'warning')
      }
    } catch (error) {
      console.error(error)
    }
  }

  const handleSelectChange = (event) => {
    try {
      setValueSelect({
        ...valueSelect,
        [event.target.name]: event.target.value
      })
    } catch (error) {
      console.error(error)
    }
  }

  const isTimeInRange = (time, change) => {
    if (change === 'I')
      return (time < minTime || time > maxTime) || (time >= blockedStartTime && time < blockedEndTime)
    else return (time < minTime || time > maxTime) || (time > blockedStartTime && time < blockedEndTime)
  }

  const handleFocusHours = (startHour, endHour) => {
    try {
      const tipoSolicitud = parseInt(valueSelect.tipoSolicitudSelected)
      
      if (tipoSolicitud === 1)
        return

      // Convertir las horas en objetos Date para facilitar la manipulación
      const horaInicioDate = new Date('2024-01-01T' + startHour)
      const horaFinDate = new Date('2024-01-01T' + endHour)

      // Calcular la diferencia en milisegundos entre las dos horas
      const diferenciaMilisegundos = horaFinDate - horaInicioDate;

      // Convertir la diferencia de milisegundos a horas
      let horas = diferenciaMilisegundos / (1000 * 60 * 60);
      
      if (startTime <= '12:00' && endTime >= '13:00') horas -= 1

      // Convertir a Dias.
      const dias = horas / 8

      // Calculamos el saldo
      const saldoDias = valueSelect.tipoSolicitudSelected === 1 ? ((values.acumulado || 0) - dias) : (values.acumulado || 0);

      setValues({
        ...values,
        cantidad: horas,
        saldo: saldoDias
      })
    } catch (error) {
      console.error(error)
    }
  }

  const handleFocusDays = (event) => {
    try {
      const tipoSolicitud = parseInt(valueSelect.tipoSolicitudSelected)
      const tipoVacacion = parseInt(valueSelect.tipoVacacionSelected)
      
      // Validar si el tipo de solicitud es Vacación, PERMISO DÍA PERSONAL o SUBSIDIO.
      if (tipoSolicitud !== 1 && !(tipoSolicitud === 2 && (tipoVacacion === 6 || tipoVacacion === 8)))
        return

      if (tipoVacacion === 2) {
        // Calculamos el saldo.      
        const saldoDias = (values.acumulado || 0) - 0.5

        setValues({
          ...values,
          cantidad: 0.5,
          saldo: saldoDias
        });
        
        return
      }
      
      // Convertimos las fechas en objetos Date.
      let dateInicio = new Date(values.fechaInicial)
      let dateFinal = new Date((tipoVacacion === 1 || tipoVacacion === 6 || (tipoSolicitud === 2 && tipoVacacion === 8)) ? values.fechaFinal : values.fechaInicial)

      // Validar si la fecha inicial ha cambiado.
      if (event.target.name === 'fechaInicial') {
        dateInicio = new Date(event.target.value)
      }
      
      // Validar si la fecha final ha cambiado.
      if (event.target.name === 'fechaFinal') {
        dateFinal = new Date(event.target.value)
      }
      
      // Obtenemos el nombre dia final seleccionado.
      const opciones = { weekday: 'long', timeZone: 'UTC' }; // Opciones para obtener el nombre del día      
      const nameDayInicial = dateInicio.toLocaleDateString('es-NI', opciones)
      const nameDayFinal = dateFinal.toLocaleDateString('es-NI', opciones)

      // Calcular la diferencia en milisegundos entre las dos fechas
      const diferenciaMilisegundos = dateFinal - dateInicio

      // Convertir la diferencia de milisegundos a días
      let dias = diferenciaMilisegundos / (1000 * 60 * 60 * 24)
      
      if (tipoVacacion === 1 || tipoVacacion === 6 || (tipoSolicitud === 2 && tipoVacacion === 8)) {
        dias += 1
      } else {
        dias += 0.5
      }
      
      /*
        Validaciones DC 20/11/2024
        Cuando es sábado y son menos de 4 días.
      */
      if (nameDayFinal === 'sábado') {
        dias -= 0.5

        setValueSelect({
          ...valueSelect,
          tipoHorarioSelected: '1'
        })
      } 
      
      // Cuando es domingo y son menos de 4 días.
      if (nameDayFinal === 'domingo') {
        // if (dias >= 4) {
        // }
        dias -= 1.5

        setValueSelect({
          ...valueSelect,
          tipoHorarioSelected: ''
        })
      }
      
      if (nameDayInicial === 'lunes' && nameDayFinal === 'domingo') {
        dias += 1.5
      }
      
      // Cuando es sábado y lunes.
      if (nameDayInicial === 'sábado' && nameDayFinal === 'lunes') {
        dias -= 1.5
      }
      
      // Cuando la cantidad de dias sea 4 se le suma 1+; y si es mayor a 5; 2+.
      let cantAdd = 1;
      const fechaNueva = new Date(values.fechaFinal)
      
      // Añadimos los días a la fecha final
      fechaNueva.setDate(fechaNueva.getDate() + cantAdd)
      const fechaFinalNueva = formatoFecha(fechaNueva)
      
      // Calculamos el saldo
      // Para PERMISO DÍA PERSONAL y SUBSIDIO no se resta del acumulado (como otros permisos)
      const saldoDias = (tipoSolicitud === 2 && (tipoVacacion === 6 || tipoVacacion === 8)) ? (values.acumulado || 0) : ((values.acumulado || 0) - dias);

      // Solo modificar fechaFinal para VACACIONES, NO para PERMISO DÍA PERSONAL ni SUBSIDIO
      if (tipoSolicitud === 1) {
        setValues({
          ...values,
          cantidad: dias,
          fechaFinal: fechaFinalNueva,
          saldo: saldoDias
        })
      } else {
        // Para PERMISO DÍA PERSONAL y SUBSIDIO, usar la fecha que seleccionó el usuario
        setValues({
          ...values,
          cantidad: dias,
          saldo: saldoDias
        })
        
        // Validación para SUBSIDIO MENOR A 3 DÍAS
        if (tipoSolicitud === 2 && tipoVacacion === 8 && dias > 3) {
          msgNotificacion('El subsidio no puede superar los 3 días', 'warning')
        }
      }
    } catch (error) {
      console.error(error)
    }
  }
  
  const formatoFecha = (fecha) => {
    const dia = String(fecha.getDate()).padStart(2, '0');
    const mes = String(fecha.getMonth() + 1).padStart(2, '0'); // Los meses son 0 indexados
    const anio = fecha.getFullYear();

    return `${anio}-${mes}-${dia}`;
  }

  const getDatosCBO = async () => {
    try {      
      EmpleadoService.getDatosCboSolicitud()
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }
  
          if (response.Codigo === 1) {
            const data = response.Data

            setDataTipoSolicitud(data?.TipoSolicitud)
            setDataTipoVacacion(data?.TipoVacacion)
          } else {
            msgNotificacion(response.Mensaje, 'warning', 500)
          }
        })
        .catch((error) => {
          msgNotificacion(error, 'error')
          dispatch(showProgress(false))
        })
    } catch (error) {
      console.error(error)
    }
  }

  const getSolicitudes = async (data) => {
    try {
      setLoading(true)

      EmpleadoService.getSolicitudesEmpleado(data)
      .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            setLoading(false)
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              const dataResponse = response?.Data              
              const dataEmpty = dataResponse.filter((item) => item.IdSolicitud === -1)[0]

              !dataEmpty ? setDataSolicitud(dataResponse) : setDataSolicitud([])
              //
              setValues({
                ...values, acumulado: dataResponse[0].Acumulado
              })
            } else {
              setDataSolicitud([])
              msgNotificacion(response.Mensaje, 'info')
            }
            setLoading(false)
          }, 500);
      })
      .catch((error) => {
        dispatch(showProgress(false));
        msgNotificacion(error, 'error')
      })
    } catch (error) {
      console.error(error)
    }
  }

  const saveSolicitud = async () => {
    try {
      const lblFecha = document.getElementById('txtFechaIni-label').innerHTML

      const data = {
        codEmpleado: userLogin.CodigoEmpleado,        
        tipoSolicitud: parseInt(valueSelect.tipoSolicitudSelected),
        tipoVacacion: parseInt(valueSelect.tipoVacacionSelected),
        fechaInicio: values.fechaInicial,
        fechaFinal: values.fechaFinal,
        horaInicio: startTime,
        horaFinal: endTime,
        motivo: motivo,
        cantDias: (parseInt(valueSelect.tipoSolicitudSelected) === 1 || (parseInt(valueSelect.tipoSolicitudSelected) === 2 && parseInt(valueSelect.tipoVacacionSelected) === 6) || (parseInt(valueSelect.tipoSolicitudSelected) === 2 && parseInt(valueSelect.tipoVacacionSelected) === 8)) ? (values.cantidad || 0) : (values.cantidad || 0) / 8,
        cantHoras: (parseInt(valueSelect.tipoSolicitudSelected) === 1 || (parseInt(valueSelect.tipoSolicitudSelected) === 2 && parseInt(valueSelect.tipoVacacionSelected) === 6) || (parseInt(valueSelect.tipoSolicitudSelected) === 2 && parseInt(valueSelect.tipoVacacionSelected) === 8)) ? (values.cantidad || 0) * 8 : (values.cantidad || 0),
      }

      //console.log(data)
      
      if (isNaN(data.tipoSolicitud)) {
        msgNotificacion('El tipo de Solicitud no está seleccionado', 'warning')
        inputEls.current['tipoSolicitudSelected'].focus()
        return
      }

      if (isNaN(data.tipoVacacion)) {
        msgNotificacion('El tipo de vacación no está seleccionado', 'warning')
        inputEls.current['tipoVacacionSelected'].focus()
        return
      }

      if (!data.fechaInicio) {
        msgNotificacion(`Debe seleccionar la ${lblFecha}` , 'warning')
        inputEls.current['fechaInicial'].focus()
        return
      }

      if (data.tipoSolicitud === 1) {
        if (data.tipoVacacion === 1) {
          if (!data.fechaFinal || data.fechaFinal === 'NaN-NaN-NaN') {
            msgNotificacion('Debe seleccionar la Fecha Final', 'warning')
            inputEls.current['fechaFinal'].focus()
            return
          }

          if (data.cantDias <= 0.5) {
            msgNotificacion('La cantidad de días tiene que ser mayor a 1, ya que es un tipo de Vacación DIA COMPLETO.', 'warning')
            inputEls.current['fechaFinal'].focus()
            return
          }
        } else {
          if (parseInt(valueSelect.tipoHorarioSelected) < 0) {
            msgNotificacion('Debe seleccionar el Tipo de Horario', 'warning')
            inputEls.current['tipoHorario'].focus()
            return
          }

          data.fechaFinal = data.fechaInicio
        }
      } else if (data.tipoSolicitud === 2 && data.tipoVacacion === 6) {
        // PERMISO DÍA PERSONAL - igual que VACACIONES DÍA COMPLETO
        if (!data.fechaFinal || data.fechaFinal === 'NaN-NaN-NaN') {
          msgNotificacion('Debe seleccionar la Fecha Final', 'warning')
          inputEls.current['fechaFinal'].focus()
          return
        }

        if (data.cantDias <= 0.5) {
          msgNotificacion('La cantidad de días tiene que ser mayor a 1, ya que es un tipo de PERMISO DÍA PERSONAL.', 'warning')
          inputEls.current['fechaFinal'].focus()
          return
        }
        // NO sobrescribir fechaFinal para PERMISO DÍA PERSONAL
      } else if (data.tipoSolicitud === 2 && data.tipoVacacion === 8) {
        // PERMISOS - SUBSIDIO MENOR A 3 DÍAS - igual que VACACIONES DÍA COMPLETO
        if (!data.fechaFinal || data.fechaFinal === 'NaN-NaN-NaN') {
          msgNotificacion('Debe seleccionar la Fecha Final', 'warning')
          inputEls.current['fechaFinal'].focus()
          return
        }

        if (data.cantDias <= 0.5) {
          msgNotificacion('La cantidad de días tiene que ser mayor a 1, ya que es un tipo de SUBSIDIO.', 'warning')
          inputEls.current['fechaFinal'].focus()
          return
        }
        // NO sobrescribir fechaFinal para SUBSIDIO
      } else {
        if (!data.horaInicio) {
          msgNotificacion('Debe seleccionar la Hora Inicial', 'warning')
          inputEls.current['horaInicial'].focus()
          return
        }

        if (!data.horaFinal) {
          msgNotificacion('Debe seleccionar la Hora Final', 'warning')
          inputEls.current['horaFinal'].focus()
          return
        }

        // Solo sobrescribir fechaFinal para permisos que NO sean PERMISO DÍA PERSONAL
        if (!(data.tipoSolicitud === 2 && data.tipoVacacion === 6)) {
          data.fechaFinal = data.fechaInicio
        }
      }

      if (!data.motivo) {
        msgNotificacion(`Digite el motivo ${data.tipoSolicitud === 1 ? 'de la vacación' : 'del permiso'}`, 'warning')
        inputEls.current['motivo'].focus()
        return
      }

      if (data.cantDias <= 0) {
        msgNotificacion('La cantidad de días es menor o igual a 0 días.', 'warning')
        inputEls.current['cantidad'].focus()
        return
      }

      // Validar si la fecha inicial es mayor a la fecha final.
      if (data.fechaInicio > data.fechaFinal) {
        msgNotificacion('La fecha inicial no puede ser mayor a la fecha final.', 'warning')
        inputEls.current['fechaInicial'].focus()
        return
      }
      
      dispatch(showProgress(true))

      EmpleadoService.procesarSolicitud(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            dispatch(showProgress(false))
            return
          }

          setTimeout(() => {
            if (response.Codigo === 1) {
              const dataRequest = {
                codEmpleado: data?.codEmpleado
              }
              
              limpiar()
              setDataSolicitud([])
              getSolicitudes(dataRequest)
              msgAlerta('Solicitud Exitosa', response.Mensaje, 'success')
            } else {
              msgAlerta('Error de validación', response.Mensaje, 'warning')
            }
            
            dispatch(showProgress(false))
          }, 1000)
          
        })
        .catch((error) => {
          console.error(error)
        })
    } catch (error) {
      console.error(error)
    }
  }

  function alertSaveSolicitud(event) {
    try {      
      let textMessage = '¿Está seguro que desea procesar la solicitud?'
      
      // Validación para SUBSIDIO MENOR A 3 DÍAS (tipoSolicitud=2, tipoVacacion=8)
      if (parseInt(valueSelect.tipoSolicitudSelected) === 2 && parseInt(valueSelect.tipoVacacionSelected) === 8) {
        if ((values.cantidad || 0) > 3) {
          msgNotificacion('El subsidio no puede superar los 3 días', 'error')
          return
        }
      }
      
      if (parseInt(valueSelect.tipoSolicitudSelected) === 1)
        textMessage = `¿Seguro que desea procesar la solicitud? ${(values.cantidad || 0) >= 4 ? `<p>Se descontarán <strong>${values.cantidad || 0}</strong> día(s) de vacación de tu saldo actual, de acorde a la política empresarial.</p>` : `<p>Se descontarán <strong>${values.cantidad || 0}</strong> día(s)</p> de tu saldo actual.`} `;
      
      event.preventDefault()
      msgAlerta('Procesar solicitud de vacación y/o permiso', textMessage, 'question', saveSolicitud)
    } catch (error) {
      console.error(error)
    }
  }

  const limpiar = () => {
    setValues({
      ...values,
      fechaInicial: '',
      fechaFinal: '',      
      cantidad: 0,
      saldo: 0,
      acumulado: 0
    })
    setValueSelect({
      ...valueSelect,
      tipoSolicitudSelected: '',
      tipoVacacionSelected: '',
      tipoHorarioSelected: ''
    })
    setStartTime('')
    setEndTime('')
    setMotivo('')
    setIsPermisoDiaPersonal(false)
    inputEls.current['tipoSolicitudSelected'].focus()
  }
  
  function alertAnularSolicitudMovil(idSolicitud) {
    try {
      try {
        msgAlerta('Anular solicitud', `¿Estás seguro que desea anular la Solicitud #${idSolicitud}?`, 'question', () => anularSolicitudMovil(idSolicitud))
      } catch (error) {
        console.error(error)
      }
    } catch (error) {
      console.error(error)
    }
  }

  const anularSolicitudMovil = (idSolicitud) => {
    try {            
      const data = {
        solicitud: idSolicitud,
        codEmpleado: userLogin.CodigoEmpleado
      }
      
      EmpleadoService.anularSolicitud(data)
        .then((response) => {
          if (!response) {
            msgNotificacion('Error de conexión con la API, consulte al administrador del sitio.', 'error')
            return
          }
          
          if (response.Codigo === 1) {
            msgAlerta('Éxito!', response.Mensaje, 'success')
            
            getSolicitudes(data)
          } else {                  
            msgAlerta('Alerta!', response.Mensaje, 'warning')
          }
        })
        .catch((error) => {
          console.log('Error:', error.message)
        })
    } catch (error) {
      console.error(error)
    }
  }
 
  let initPage = false

  useEffect(() => {
    document.title = `Solicitud de Vacación o Permiso - ${NAME_PROJECT}`

    try {      
      dispatch(showProgress(true))
                  
      setTimeout(() => {        
        if (!initPage) {          
          initPage = true;
          
          const data = {
            codEmpleado: userLogin.CodigoEmpleado            
          }
  
          getSolicitudes(data)
          getDatosCBO()  
        }
        
        dispatch(showProgress(false))
      }, 1000)
      
    } catch (error) {
      console.error(error)
    }
  }, [])

  useEffect(() => {
    try {
      const tipoSolicitud = parseInt(valueSelect.tipoSolicitudSelected)
      
      if (tipoSolicitud > 0) {
        setValues({
          ...values,
          fechaInicial: '', 
          fechaFinal: '',
          cantidad: 0
        })

        setStartTime('')
        setEndTime('')

        if (tipoSolicitud === 1) {
          setIsVacacion(true)
        } else {
          setIsVacacion(false)
        }        

        //
        const dataFilter = dataTipoVacacion.filter((item) => item.IdTipoSolicitud === tipoSolicitud)
        setDataTipoVacacionFilter(dataFilter)
      }            
    } catch (error) {
      console.error(error)
    }
  }, [dataTipoVacacion, valueSelect.tipoSolicitudSelected])

  useEffect(() => {
    try {
      const tipoSolicitud = parseInt(valueSelect.tipoSolicitudSelected)
      const tipoVacacion = parseInt(valueSelect.tipoVacacionSelected)
      const tipoHorario = parseInt(valueSelect.tipoHorarioSelected)

      setValues({
        ...values,
        fechaInicial: '',
        fechaFinal: '',
        cantidad: 0,
        saldo: 0
      })

      if (tipoVacacion === 1 && tipoSolicitud === 1) {
        // VACACIONES - DÍA COMPLETO
        setIsMediodia(false)
        setIsHorario(true)

        setStartTime('08:00')
        setEndTime('17:00')
      } else if (tipoVacacion === 8 && tipoSolicitud === 2) {
        // PERMISOS - SUBSIDIO MENOR A 3 DÍAS (igual que día completo)
        setIsMediodia(false)
        setIsHorario(true)

        setStartTime('08:00')
        setEndTime('17:00')
      } else if (tipoSolicitud === 1) {
        // VACACIONES - MEDIO DÍA
        setIsMediodia(true)
        setIsHorario(false)
        
        if (tipoHorario > 0) {
          if (tipoHorario === 1) {
            setStartTime('08:00')
            setEndTime('12:00')
          } else {
            setStartTime('13:00')
            setEndTime('17:00')
          }
        } else {
          setStartTime('')
          setEndTime('')
        }
      } else if (tipoSolicitud === 2 && tipoVacacion === 6) {
        // PERMISOS - DÍA PERSONAL (similar a vacaciones día completo)
        setIsMediodia(false)
        setIsHorario(true)
        setIsPermisoDiaPersonal(true)

        setStartTime('08:00')
        setEndTime('17:00')
      } else {
        // PERMISOS - OTROS TIPOS
        setIsMediodia(true)
        setIsHorario(true)
        setIsPermisoDiaPersonal(false)
      }
    } catch (error) {
      console.error(error)
    }
  }, [valueSelect.tipoVacacionSelected])

  useEffect(() => {
    const tipoHorario = parseInt(valueSelect.tipoHorarioSelected)
    const tipoVacacion = parseInt(valueSelect.tipoVacacionSelected) 

    if (tipoVacacion === 2) {      
      if (tipoHorario <= 0) {
        setStartTime('')
        setEndTime('') 
      } else {
        if (tipoHorario === 1) {
          setStartTime('08:00')
          setEndTime('12:00')
        } else {
          setStartTime('13:00')
          setEndTime('17:00')
        }
      }
      
      // const saldo = values.acumulado - 0.50      
  
      // setValues({
      //   ...values,
      //   cantidad: 0.50,
      //   saldo: saldo
      // })
    }
  }, [valueSelect.tipoHorarioSelected])

  return <div className='App-content'>
    <Heading className='mt-0 py-0 w-100 heading justify-content-center'>
      <div className='heading-text'>
        <i className='bx bxs-calendar-plus me-2'></i>
        <span>Solicitud de Vacación o Permiso</span>
      </div>
    </Heading>

    <Grid container spacing={1} paddingX={1} paddingBottom={1} paddingTop={2}>
      <Typography component='div' className='col-md-6 dv-title' textAlign='center'>
        No. Empleado: <span className='text-warning'>{userLogin?.CodigoEmpleado}</span>
      </Typography>

      <Typography component='div' className='col-md-6 dv-title' textAlign='center'>
        Nombre del Empleado: <span className='text-warning'>{userLogin?.Nombre.toUpperCase()}</span>
      </Typography>

      <Grid item xs={12} md={3}>
        <Item>   
          <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth size='small'>
              <InputLabel id='TipoLabel' className='text-transform-none'>
                Tipo de Solicitud
              </InputLabel>
              <Select
                id='cboTipo'
                name='tipoSolicitudSelected'
                label='Tipo de Solicitud'
                value={valueSelect.tipoSolicitudSelected}
                onChange={handleSelectChange}
                fullWidth
                size='small'
                className='text-start'
                displayEmpty
                inputRef={(el) => (inputEls.current['tipoSolicitudSelected'] = el)}                
              >
                {
                  dataTipoSolicitud?.map((item) => {
                    return (
                      <MenuItem key={item.Id} value={item.Id.toString()}>{item.Nombre}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Box>
        </Item>
      </Grid>

      <Grid item xs={12} md={3}>
        <Item>
          <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth size='small'>
              <InputLabel id='TipoVacacionLabel' className='text-transform-none'>
                {parseInt(valueSelect.tipoSolicitudSelected) === 1 ? 'Tipo de Vacación' : 'Tipo de Permiso'}
              </InputLabel>
              <Select
                id='cboTipoVacacion'
                name='tipoVacacionSelected'
                label={parseInt(valueSelect.tipoSolicitudSelected) === 1 ? 'Tipo de Vacación' : 'Tipo de Permiso'}
                value={valueSelect.tipoVacacionSelected}
                onChange={handleSelectChange}
                fullWidth
                size='small'
                className='text-start'
                displayEmpty
                inputRef={(el) => (inputEls.current['tipoVacacionSelected'] = el)}
              >
                {
                  dataTipoVacacionFilter?.map((item) => {
                    return (
                      <MenuItem key={item.Id} value={item.Id.toString()}>{item.Nombre}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Box>
        </Item>
      </Grid>
      
      <Grid item xs={12} md={2}>
        <Item>
          <TextField
            id='txtFechaIni'
            name='fechaInicial'
            type='date'            
            label={`${isMediodia ? 'Fecha' : 'Fecha Inicial'}`}
            size='small'
            className='me-2'
            fullWidth
            onChange={(event) => {
              handleFocusDays(event); // Llama a la función para calcular la cantidad de días
              handleChange(event); // Actualiza el estado
            }}           
            value={values.fechaInicial}
            inputRef={(el) => (inputEls.current['fechaInicial'] = el)}
            InputLabelProps={{
              shrink: true              
            }}
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={2} hidden={isMediodia}>
        <Item>
          <TextField
            id='txtFechaFin'
            name='fechaFinal'
            type='date'
            label='Fecha Final'
            size='small'
            className='me-2'
            fullWidth
            onChange={(event) => {
              handleFocusDays(event); // Llama a la función para calcular la cantidad de días
              handleChange(event); // Actualiza el estado
            }}
            value={values.fechaFinal}
            inputRef={(el) => (inputEls.current['fechaFinal'] = el)}
            InputLabelProps={{
              shrink: true
            }}
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={isMediodia ? 4 : 2}>
        <Item>   
          <Box sx={{ minWidth: 200 }}>
            <FormControl fullWidth size='small'>
              <InputLabel id='TipoLabel' className='text-transform-none'>
                Horario
              </InputLabel>
              <Select
                id='cboHorario'
                name='tipoHorarioSelected'
                label='Horario'
                value={valueSelect.tipoHorarioSelected}
                onChange={handleSelectChange}
                fullWidth
                size='small'
                className='text-start'
                displayEmpty
                readOnly={isHorario}
                inputRef={(el) => (inputEls.current['tipoHorario'] = el)}
              >
                {
                  rowTipoHorario?.map((item) => {
                    return (
                      <MenuItem key={item.Id} value={item.Id.toString()}>{item.Nombre}</MenuItem>
                    )
                  })
                }
              </Select>
            </FormControl>
          </Box>
        </Item>
      </Grid>

      <Grid item xs={12} md={2} >
        <Item>
          <TextField
            id='txtHoraIni'
            name='horaInicial'
            type='time'
            label='Hora Inicial'
            size='small'
            className='me-2'
            fullWidth
            onChange={(event) => {              
              //handleChange(event)
              handleStartTimeChange(event)// Actualiza el estado              
            }}
            //onFocus={handleFocusHours}            
            //onBlur={handleFocusHours}
            value={startTime}
            inputRef={(el) => (inputEls.current['horaInicial'] = el)}
            InputLabelProps={{
              shrink: true              
            }}
            InputProps={{
              readOnly: isVacacion || isPermisoDiaPersonal
            }}
            inputProps={{
              step: 300,
            }}
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={2} >
        <Item>
          <TextField
            id='txtHoraFin'
            name='horaFinal'
            type='time'
            label='Hora Final'
            size='small'
            className='me-2'
            fullWidth            
            onChange={(event) => {
              //handleFocusDays(event); // Llama a la función para calcular la cantidad de días
              //handleChange(event)
              handleEndTimeChange(event)// Actualiza el estado              
            }}
            // onFocus={handleFocusHours}
            // onBlur={handleFocusHours}
            value={endTime}
            inputRef={(el) => (inputEls.current['horaFinal'] = el)}
            InputLabelProps={{
              shrink: true              
            }}
            InputProps={{
              readOnly: isVacacion || isPermisoDiaPersonal
            }}
            inputProps={{
              step: 300,
            }}
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={2}>
        <Item>
          <TextField
            id='txtAcumulado'
            type='text'
            label='Acumulado'
            size='small'
            className='me-2'
            fullWidth
            value={values.acumulado ? values.acumulado.toFixed(2) : '0.00'}
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              readOnly: true
            }}
            inputProps={{
              className: 'text-end fw-bolder'
            }}
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={3}>
        <Item>
          <TextField
            id='txtCantidad'
            name='cantidad'
            type='text'
            label={`${(parseInt(valueSelect.tipoSolicitudSelected) === 1 || (parseInt(valueSelect.tipoSolicitudSelected) === 2 && parseInt(valueSelect.tipoVacacionSelected) === 6) || (parseInt(valueSelect.tipoSolicitudSelected) === 2 && parseInt(valueSelect.tipoVacacionSelected) === 8)) ? 'Cantidad (días)' : 'Cantidad (horas)'}`}
            size='small'
            className='me-2'
            fullWidth            
            inputRef={(el) => (inputEls.current['cantidad'] = el)}
            value={values.cantidad ? values.cantidad.toFixed(2) : '0.00'}
            InputLabelProps={{
              shrink: true              
            }}
            InputProps={{
              readOnly: true
            }}
            inputProps={{
              className: 'text-end fw-bolder text-blue'
            }}
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={3} >
        <Item>
          <TextField
            id='txtSaldo'
            type='text'
            label='Saldo'
            size='small'
            className='me-2'
            fullWidth
            value={values.saldo ? values.saldo.toFixed(2) : '0.00'}
            InputLabelProps={{
              shrink: true
            }}
            InputProps={{
              readOnly: true
            }}
            inputProps={{
              className: 'text-end fw-bolder text-danger'
            }}
          />
        </Item>
      </Grid>

      <Grid item xs={12} md={12}>
        <Item>
          <TextField
            id='txtMotivo'
            name='motivo'
            type='text'
            label='Motivo'
            fullWidth
            multiline
            onChange={(e) => setMotivo(e.target.value)}
            value={motivo}
            inputRef={(el) => (inputEls.current['motivo'] = el)}
            placeholder={`${valueSelect.tipoSolicitudSelected === 1 ? 'Digite el motivo de la vacación' : 'Digite el motivo del Permiso'}`}
            InputLabelProps={{
              shrink: true
            }}
          />
        </Item>
      </Grid>
    
    
    <Grid item xs={12} md={12} hidden={!isMobile} display='flex' justifyContent='center' marginTop={1} marginBottom={2}>      
        <Button
          variant='contained'
          className='text-transform-none float-right mx-1'
          color='error'
          onClick={limpiar}
          size='small'
          startIcon={<DeleteForeverIcon />}        
        >
          Limpiar
        </Button>
        <Button
          variant='contained'
          className='text-transform-none float-right mx-1'
          color='success'
          onClick={alertSaveSolicitud}
          startIcon={<PublishedWithChangesIcon />}
        >
          Guardar solicitud
        </Button>      
    </Grid>

      {isMobile ? (
        // Vista móvil: Lista de tarjetas
        <Grid container spacing={1} paddingLeft={1} paddingTop={1} justifyContent='center'>
          <Typography variant="h6" marginTop={2} color='#ffc107'><strong>HISTORIAL DE SOLICITUDES</strong></Typography>
          {dataSolicitud.map((row) => (
            <Grid item xs={12} key={row.IdSolicitud}>
              <Card>
                <CardContent>
                  <Typography variant="h6"><strong>Solicitud #{row.IdSolicitud}</strong></Typography>
                  <Typography variant="body2">
                    <strong>Empleado: </strong><span className='mx-1'>{row.CodigoEmpleado} - {row.NombreEmpleado}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Solicitud:</strong><span className='mx-1'>{Formatter.dateTimeFormatter(row.FechaReg)}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Inicio:</strong><span className='mx-1'>{Formatter.dateTimeFormatter(row.FechaInicio)}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Fecha Final:</strong><span className='mx-1'>{Formatter.dateTimeFormatter(row.FechaFinal)}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Días:</strong><span className='mx-1 fw-bolder text-blue'>{row.CantDias}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Horas:</strong><span className='mx-1 fw-bolder text-blue'>{row.CantHoras}</span>
                  </Typography>
                  <Typography variant="body2">
                  <strong>Tipo:</strong><span className={`mx-1 ${row.TipoSolicitud === 'VACACIONES' ? 'text-danger fw-bolder': 'text-blue fw-bolder'}`}>{row.TipoSolicitud}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Solicitud:</strong><span className='mx-1'>{row.TipoVacacion}</span>
                  </Typography>
                  <Typography variant="body2">
                    <strong>Motivo:</strong><span className='mx-1'>{row.Motivo}</span>
                  </Typography>
                  <Typography variant="body2" className={row.CssBg} display='flex' alignItems='center' borderRadius={4}>
                    <i className={`${row.CssIcon} mx-1`}></i>
                    <strong>Estado:</strong><span className='mx-1'>{row.Estado}</span>
                  </Typography>
                  <div style={{ marginTop: '10px' }} >
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => alertAnularSolicitudMovil(row.IdSolicitud)}
                      className={`text-transform-none me-2 ${hiddeButtonsMobile.includes(row.IdEstado) ? 'd-none' : ''}`}
                    >
                      Anular
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Grid item xs={12} md={12}>
          <Item className='MuiPaper-root-dataGrid-solicitud'>
            <SolicitudesDataGrid
              rows={dataSolicitud}
              columns={columns}
              getRowId={(row) => row?.IdSolicitud}
              pageSize={PAGE_SIZE}
              pageSizeOptions={[5, 10, 25, 50, 100]}
              loading={loading}
              localeText={Formatter.localizedTextsMapColumns}
              getRowClassName={(params) => `super-app-theme--${params.row?.Estado}`}
              // Ocultar la casilla de check all.
              sx={{
                "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer": {
                  display: "none"
                }
              }}
              showCellVerticalBorder
              showColumnVerticalBorder
              density='compact'
              slots={{
                noRowsOverlay: CustomNoRowsOlverlay
              }}
            />
          </Item>
        </Grid>
      )
      }
    </Grid>

    <Heading className='mt-auto w-100 justify-content-end heading position-sticky bottom-0' hidden={isMobile}>
      <Button
        variant='outlined'
        className='text-transform-none float-right mx-1'
        color='error'
        onClick={limpiar}
        size='small'
        startIcon={<DeleteForeverIcon />}        
      >
        Limpiar
      </Button>
      <Button
        variant='contained'
        className='text-transform-none float-right mx-1'
        color='success'
        onClick={alertSaveSolicitud}
        startIcon={<PublishedWithChangesIcon />}
      >
        Guardar solicitud
      </Button>
    </Heading>
  </div>
}